function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  fill: "#00923f",
  width: 900,
  height: 600
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "#0051ba",
  width: 900,
  height: 400
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  fill: "white",
  width: 900,
  height: 200
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: 1,
  d: "M367 288l24 36 62 0 24 -36m-44 -6l14 12m-50 0l14 -12m-26 -6l32 48 10 0 32 -48",
  fill: "none",
  stroke: "gold",
  strokeWidth: 12,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#1",
  transform: "translate(140)"
});

var _ref7 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#1",
  transform: "translate(280)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#d81e05",
  d: "M0,600 0,0 225,300z"
});

var SvgFlagOfTyumenOblast = function SvgFlagOfTyumenOblast(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200px",
    height: "800px",
    viewBox: "0 0 900 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlagOfTyumenOblast, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Flag_of_Tyumen_Oblast.7dbd6493.svg";
export { ForwardRef as ReactComponent };